import React, { useMemo } from 'react';
import { parseISO, format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import enUS from 'date-fns/locale/en-US';
import classes from './FeedbackUpdateBanner.scss';
import { FeedbackUpdateBannerProps } from '../types.d';

const FeedbackUpdateBanner = ({
  updatedBy,
  updatedDate,
  timeZone,
}: FeedbackUpdateBannerProps): React.ReactElement | null => {
  const formattedDate = useMemo(() => {
    if (!updatedDate) return null;
    try {
      const date = parseISO(updatedDate);
      const zonedDate = timeZone ? utcToZonedTime(date, timeZone) : date;
      return `on ${format(zonedDate, 'MMM d, yyyy', { locale: enUS })}`;
    } catch (error) {
      return null;
    }
  }, [updatedDate, timeZone]);

  if (!updatedBy || !formattedDate) {
    return null;
  }

  return (
    <div className={classes.FeedbackUpdateBanner}>
      <div className={classes.FeedbackUpdateBanner__Content}>
        <span className={classes.FeedbackUpdateBanner__Text}>
          Feedback last updated by:
          {' '}
          <strong className={classes.FeedbackUpdateBanner__Name}>{updatedBy}</strong>
          {' '}
          {formattedDate}
        </span>
      </div>
    </div>
  );
};

export default FeedbackUpdateBanner;
